module.exports = __webpack_public_path__ + "img/banner11.ecfa3aa1.jpg";